import axios, { AxiosError } from 'axios';

import { buildURL } from '../webservice';

const BASE_URL = process.env.REACT_APP_PAYMENTS_API_URL!;

const verifyGiftCard = async (code: string) => {
    try {
        const url = buildURL(BASE_URL, `/v2/gift-cards/${code}/verify`);
        const response = await axios.get(url);
        return response.data;
    } catch (err) {
        console.log(err);
        if (err instanceof AxiosError) {
            return err.response?.data;
        }
        return null;
    }
};

export { verifyGiftCard };
